import { createSlice } from '@reduxjs/toolkit'

import {
  resetImportExternalSourceData,
  setIsListenSocketSchoolImport,
  setIsOpenImportDialog,
  setIsOpenImportProgressDialog,
  setIsOpenImportedSubscribersResultDialog,
  setSchoolImportProcessStatus,
  setShowProgressBar,
} from './reducers'
import {
  cancelImportSISDataThunk,
  checkSISDataImportThunk,
  enableAutoSyncThunk,
  getConnectedSISThunk,
  importSISDataThunk,
} from './importExternalSourceReducers'

export const initialState = {
  connectedSIS: {},
  schoolImportProcessStatusData: {
    status: '',
    historyId: null,
  },
  checkImportData: {
    id: null,
    userId: null,
    showDialog: false,
    isInProcess: false,
    importStatus: null,
    createdTagCount: 0,
    createdGroupCount: 0,
    createdSubscribersCount: 0,
  },
  enableAutoSyncLoading: false,
  isClickedImportBtn: false,
  isListenSocketSchoolImport: false,
  checkImportStatus: 'idle',
  getStatus: 'idle',
  importSISStatus: 'idle',
  showProgressBar: false,
  isOpenImportDialog: null,
  isOpenImportProgressDialog: false,
  isOpenImportedSubscribersResultDialog: false,
}

const importExternalSourceSlice = createSlice({
  name: 'importExternalSourceData',
  initialState,
  reducers: {
    setIsOpenImportedSubscribersResultDialog,
    setIsListenSocketSchoolImport,
    resetImportExternalSourceData,
    setIsOpenImportProgressDialog,
    setSchoolImportProcessStatus,
    setIsOpenImportDialog,
    setShowProgressBar,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getConnectedSISThunk.fulfilled.type, (state, action) => {
        state.connectedSIS = action.payload
        state.getStatus = 'success'
      })
      .addCase(getConnectedSISThunk.rejected.type, (state) => {
        state.getStatus = 'failed'
      })
      .addCase(getConnectedSISThunk.pending.type, (state) => {
        state.getStatus = 'loading'
      })
      .addCase(checkSISDataImportThunk.fulfilled.type, (state, action) => {
        const {
          data,
          currentUserId,
          schoolId = null,
          isClickedImportBtn,
        } = action.payload
        const { showDialog, userId, id, isInProcess } = data

        if (currentUserId === userId) {
          state.isOpenImportedSubscribersResultDialog = showDialog
          if (isInProcess) {
            state.isListenSocketSchoolImport = true
            state.showProgressBar = true
          } else {
            state.isOpenImportDialog = schoolId
          }
        } else if (!isInProcess) {
          state.isOpenImportDialog = schoolId
        }
        state.isClickedImportBtn = isClickedImportBtn
        state.schoolImportProcessStatusData.historyId = id
        state.checkImportData = data
        state.checkImportStatus = 'success'
      })
      .addCase(checkSISDataImportThunk.rejected.type, (state) => {
        state.checkImportStatus = 'failed'
      })
      .addCase(checkSISDataImportThunk.pending.type, (state) => {
        state.checkImportStatus = 'loading'
      })
      .addCase(importSISDataThunk.fulfilled.type, (state) => {
        state.importSISStatus = 'success'
        state.isOpenImportDialog = null
      })
      .addCase(importSISDataThunk.rejected.type, (state) => {
        state.importSISStatus = 'failed'
        state.isOpenImportDialog = null
        state.isOpenImportProgressDialog = false
        state.showProgressBar = false
      })
      .addCase(importSISDataThunk.pending.type, (state) => {
        state.importSISStatus = 'loading'
        state.isOpenImportProgressDialog = true
        state.isListenSocketSchoolImport = true
        state.isOpenImportDialog = null
        state.showProgressBar = true
      })
      .addCase(cancelImportSISDataThunk.fulfilled.type, (state) => {
        return {
          ...initialState,
          connectedSIS: state.connectedSIS,
          getStatus: state.getStatus,
        }
      })
      .addCase(cancelImportSISDataThunk.pending.type, (state) => {
        state.isOpenImportProgressDialog = false
      })
      .addCase(enableAutoSyncThunk.fulfilled.type, (state, action) => {
        const { data } = action?.meta?.arg || {}
        state.enableAutoSyncLoading = false
        state.connectedSIS.syncEnabled = data.enable
      })
      .addCase(enableAutoSyncThunk.pending.type, (state) => {
        state.enableAutoSyncLoading = true
      })
      .addCase(enableAutoSyncThunk.rejected.type, (state) => {
        state.enableAutoSyncLoading = false
      })
  },
})

export default importExternalSourceSlice
